<script setup>
const $props = defineProps({
  id: {
    type: [Number, String],
    required: true
  },
  name: {
    type: String,
    default: ''
  },
  closable: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: 'default'
  }
})
const $emits = defineEmits(['close'])

const onClose = () => {
  $emits('close', $props.id)
}
</script>

<template>
  <el-tag :closable="closable" :size="size" @close="onClose">
    <span class="dept-tag-name">{{ name || id }}</span>
  </el-tag>
</template>

<style scoped lang="scss">
.dept-tag-name {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
